
import { Component, ElementRef, Self, Input }  from '@angular/core';
import { NgControl } from '@angular/forms';

import { AbstractDateTimePicker } from './date-time-picker'

@Component({
	selector: 'date-picker',
	templateUrl: "./date-time-picker.html",
	styles: [require("./date-time-picker.scss")]
})
export class DatePicker extends AbstractDateTimePicker {
	@Input() placeholder: string
	constructor(ngControl: NgControl, elementRef: ElementRef) {
		super(ngControl, elementRef);
	}

	public getDisplayDateFormat() {
		return "DD.MM.YYYY";
	}

	public getBackendDateFormat() {
		return "YYYY-MM-DDTHH:mm:00";
	}

	public getDatePickerFormat() {
		return "d.m.Y"
	}
	public getShowTimepicker() {
		return false;
	}

	public getShowDatepicker() {
		return true;
	}

	public getInternalDateFormatFrom() {
		return "YYYY-MM-DDTHH:mm:ss"
	}

	public getInternalDateFormatTo() {
		return "DD.MM.YYYY"
	}

	public getDatePickerMinDate() {
		return false;
	}
	public getDayOfWeekStart() {
		return 1;
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/date-time-picker/date-picker.component.ts